import { render } from "./JuranetDoc.vue?vue&type=template&id=7d3527a2"
import script from "./JuranetDoc.vue?vue&type=script&lang=ts"
export * from "./JuranetDoc.vue?vue&type=script&lang=ts"
script.render = render

export default script